import { Dispatch, SetStateAction, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Popup } from '@/components/common/Popup';
import { isPhoneOrHighScreen } from '@/utilities/sizeUtils';
import StreamChatBody from './StreamChatBody';
import { chatContext } from '@/contexts/ChatContext';

import './index.css';

export type LayoutStage = 'list' | 'channel' | 'thread' | 'search';

const StreamChat = ({
  layout,
  setLayout,
}: {
  layout: LayoutStage;
  setLayout: Dispatch<SetStateAction<LayoutStage>>;
}) => {
  const { t } = useTranslation();
  const chatCtx = useContext(chatContext);
  if (!chatCtx || !chatCtx.chatId) {
    return <div className="no-chat-container">{t('streamChat.custom.chatNotAvailable')}</div>;
  }
  if (window.clearAllNotifications) {
    window.clearAllNotifications.postMessage('');
  }
  return <StreamChatBody layout={layout} setLayout={setLayout} />;
};

function StreamChatPopup({ closePopup }: { closePopup: () => Promise<void> }) {
  const { t } = useTranslation();
  const [layout, setLayout] = useState<LayoutStage>('list');

  const popupTitle = layout === 'list' ? t('mainMenu.messages') : '';
  const header = undefined;
  const body = (
    <div className={`pluto-chat channel-layout-${layout}`}>
      <StreamChat layout={layout} setLayout={setLayout} />
    </div>
  );
  const footer = undefined;

  if (isPhoneOrHighScreen()) {
    return (
      <Popup
        popupTitle={popupTitle}
        header={header}
        body={body}
        footer={footer}
        closePopup={closePopup}
        isFullScr={true}
        showCloseButton={false}
        leftText={true}
      />
    );
  }

  return (
    <>
      {header}
      {body}
    </>
  );
}

export default StreamChatPopup;
